const PIN_ACCESS_CACHE_KEY = "pin_access_granted";
const PIN_ACCESS_EVENT_NAME = "pin_access_change";

const emitPinAccessChange = (value: boolean): void => {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(
      new CustomEvent(PIN_ACCESS_EVENT_NAME, { detail: { value } })
    );
  } catch {
    // ignore dispatch errors
  }
};

export const getCachedPinAccess = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(PIN_ACCESS_CACHE_KEY) === "true";
  } catch {
    return false;
  }
};

export const setCachedPinAccess = (value: boolean): void => {
  if (typeof window === "undefined") return;
  try {
    if (value) {
      localStorage.setItem(PIN_ACCESS_CACHE_KEY, "true");
    } else {
      localStorage.removeItem(PIN_ACCESS_CACHE_KEY);
    }
    emitPinAccessChange(value);
  } catch {
    // ignore storage errors
  }
};

export const clearCachedPinAccess = (): void => {
  setCachedPinAccess(false);
};

export const subscribeToPinAccess = (
  callback: (value: boolean) => void
): (() => void) => {
  if (typeof window === "undefined") return () => undefined;

  const handleCustomEvent = (event: Event) => {
    const detailValue = (event as CustomEvent<{ value?: boolean }>).detail
      ?.value;
    if (typeof detailValue === "boolean") {
      callback(detailValue);
      return;
    }
    callback(getCachedPinAccess());
  };

  const handleStorage = (event: StorageEvent) => {
    if (event.key !== PIN_ACCESS_CACHE_KEY) return;
    callback(event.newValue === "true");
  };

  window.addEventListener(
    PIN_ACCESS_EVENT_NAME,
    handleCustomEvent as EventListener
  );
  window.addEventListener("storage", handleStorage);

  return () => {
    window.removeEventListener(
      PIN_ACCESS_EVENT_NAME,
      handleCustomEvent as EventListener
    );
    window.removeEventListener("storage", handleStorage);
  };
};
